import { render, staticRenderFns } from "./PaywallFeatures.vue?vue&type=template&id=11d346ec&scoped=true&"
import script from "./PaywallFeatures.vue?vue&type=script&lang=ts&"
export * from "./PaywallFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallFeatures.vue?vue&type=style&index=0&id=11d346ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d346ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('11d346ec', component.options)
    } else {
      api.reload('11d346ec', component.options)
    }
    module.hot.accept("./PaywallFeatures.vue?vue&type=template&id=11d346ec&scoped=true&", function () {
      api.rerender('11d346ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/PaywallFeatures.vue"
export default component.exports